import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ExpressionBuilderComponent } from '../../rule-config-component/expression-builder/expression-builder.component';
import { routingExpressionPrep } from './routing-ruleconfig1-expression-prep.util';
import { RuleEngineService } from '../../services/rule-engine.service';
import type { RoutingPipelineBlock } from '../models/routing-ruleconfig1.models';

/** Opens Expression Builder — display labels in UI; block stores labels until save converts to numbers. */
@Injectable()
export class RoutingRuleconfig1ExpressionService {
  constructor(
    private readonly dialog: MatDialog,
    private readonly ruleEngineService: RuleEngineService
  ) {}

  openForBlock(block: RoutingPipelineBlock): void {
    if (!block.rules?.length) {
      return;
    }
    const displayExpression =
      routingExpressionPrep.resolveFinalExpressionForBlock(block) ||
      (block.ruleSatisfaction ?? '').toString();
    routingExpressionPrep.prepareForBlock(block, this.ruleEngineService);
    const ref = this.dialog.open(ExpressionBuilderComponent, {
      height: '85%',
      width: '90%',
      maxHeight: '18vw !important',
      data: {
        enableRoutingManualExpressionInput: true,
        manualExpression: displayExpression,
      },
      disableClose: true,
      panelClass: 'custom-dialog-container',
      autoFocus: false,
    });
    ref.afterClosed().subscribe(
      (dialogResult: { confirmed?: boolean; finalExpression?: string; builderData?: unknown } | undefined) => {
        if (!dialogResult?.confirmed) {
          return;
        }
        const fromDialog = (dialogResult.finalExpression ?? '').toString().trim();
        const fromBuilder = routingExpressionPrep.buildFinalFromBuilderData(dialogResult.builderData);
        const updated = fromDialog || fromBuilder;
        if (!updated) {
          return;
        }
        block.ruleSatisfaction =
          routingExpressionPrep.resolveFinalExpressionForBlock({
            rules: block.rules,
            ruleSatisfaction: updated,
          }) || updated;
      }
    );
  }
}
